const session = {
    hm: null,
    checkAuthUrl: '',
    loggedIn: false,
    isEmployee: false,
    currentEmployeesStatus: false,
    employeeMenuComponentIds: [],
    timeLeft: 0,

    timeoutModal: false,
    timeoutChartHolder: false,
    timeoutChart: false,
    timeoutMaxTime: 1,
    timeoutRemainingTime: 1,
    timeoutInterval: false,

    extendSession: async function (performCheckAuth = false) {
        await this.hm.app.fetchJson('authentication', 'extendSession');
        if (performCheckAuth) {
            this.checkAuth();
        }
    },

    setIntervals: function () {
        setInterval(() => { this.checkAuth(); }, 1000 * 60);
        if (this.isEmployee) {
            setInterval(() => { this.checkEmployeeStatus(); }, 1000 * 60);
            setInterval(() => { this.checkEmployeeStatusCookie(); }, 1000 * 15 + 10);
        }
    },

    checkEmployeeStatus: async function () {
        await this.hm.app.fetchJson('employeesStatus', 'check');
    },

    checkEmployeeStatusCookie: function () {
        let employeesStatus = this.hm.helper.getCookieValue('employeesStatus');

        if (employeesStatus !== this.currentEmployeesStatus) {
            this.employeeMenu();
        }
    },

    checkAuth: async function () {
        if (this.loggedIn) {
            fetchConfig = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "pageToken": this.hm.app.pageToken
                })
            }

            let jsonResponse = await this.hm.helper.fetchJson(this.checkAuthUrl, fetchConfig);

            if (jsonResponse !== false) {
                this.loggedIn = jsonResponse._loggedIn;
                if (!this.loggedIn) {
                    window.location.assign(this.hm.app.baseUrl);
                }

                this.timeLeft = parseInt(jsonResponse._sessionTimeLeft);

                if (this.timeLeft < 100 && this.timeLeft > -36000) {
                    //warn session is about to end
                    this.sessionTimeoutWarning();
                } else if (this.timeoutModal !== false) {
                    //remove session warning modal
                    this.removeModal();
                }

                if (typeof jsonResponse._assistedBy !== typeof undefined && parseInt(jsonResponse._assistedBy) > 0) {
                    //show assistance indicator
                } else {
                    //hide assistance indicator
                }
            } else {
                this.hm.error('failed checkAuth');
            }
        }
    },

    sessionTimeoutWarning: function () {
        if (this.timeoutModal === false) {
            this.timeoutModal = this.hm.newComponent('modal');
            this.timeoutModal.init();

            let timeoutModalContent = this.hm.helper.getTemplate('sessionTimeout');

            this.timeoutModal.setContent(timeoutModalContent);

            this.timeoutChartHolder = this.timeoutModal.element.querySelector('[data-zit-subelement-type="chart"]');

            let extendButtonHTML = '<button class="' + this.hm.app.cssClass('primaryButton') + '">' + this.hm.app.utext('extend') + '</button>';
            let extendButton = this.hm.helper.string2element(extendButtonHTML);

            extendButton.addEventListener('click', (e) => { this.extendSession(true); });

            this.timeoutModal.element.addEventListener('hidden.bs.modal', (e) => { this.removeModal(); })

            this.timeoutModal.addAction(extendButton);
            this.renderChart();
            this.timeoutModal.open();
        }
    },

    removeModal: function () {
        this.clearTimeoutInterval();
        this.timeoutModal.dispose();
        this.timeoutModal = false;
    },

    renderChart: function () {
        this.timeoutMaxTime = this.timeLeft;
        this.timeoutRemainingTime = this.timeLeft;

        let options = {
            series: [100],
            chart: {
                height: 350,
                type: 'radialBar',
                offsetY: -10
            },
            plotOptions: {
                radialBar: {
                    startAngle: -135,
                    endAngle: 135,
                    dataLabels: {
                        name: {
                            fontSize: '16px',
                            color: undefined,
                            offsetY: 120
                        },
                        value: {
                            offsetY: 76,
                            fontSize: '22px',
                            color: undefined,
                            formatter: (val) => {
                                return this.timeoutRemainingTime + "s";
                            }
                        }
                    }
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    shadeIntensity: 0.15,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 50, 65, 91]
                },
            },
            stroke: {
                dashArray: 4
            },
            labels: [''],
        };

        this.timeoutChart = new ApexCharts(this.timeoutChartHolder, options);
        this.timeoutChart.render();

        this.timeoutInterval = setInterval(() => { this.updateChart(); }, 1000);
    },

    updateChart: function () {
        this.timeoutRemainingTime--;
        let remainingPercent = this.timeoutRemainingTime * 100 / this.timeoutMaxTime;
        let options = {
            series: [remainingPercent]
        };
        this.timeoutChart.updateOptions(options);

        if (this.timeoutRemainingTime <= 0) {
            this.checkAuth();
            if (this.timeLeft < 5) {
                this.hm.log('disconnecting');
                this.clearTimeoutInterval();
                this.timeoutModal.element.querySelector('[data-zit-subelement-type="message"]').innerHTML = this.hm.app.utext('disconnecting');
                window.location.assign(this.hm.app.baseUrl + this.hm.app.aliases.authentication + '/' + this.hm.app.aliases.logout + '/');
            } else {
                this.removeModal();
            }
        }
    },

    clearTimeoutInterval: function () {
        if (this.timeoutInterval !== false) {
            clearInterval(this.timeoutInterval);
            this.timeoutInterval = false;
            this.timeoutChartHolder = false;
            this.timeoutChart.destroy();
            this.timeoutChart = false;
            this.timeoutMaxTime = 1;
            this.timeoutRemainingTime = 1;
        }
    },

    employeeMenu: async function () {
        if (this.isEmployee) {
            let employeeMenuElement = document.getElementById('employeeMenu');

            if (this.employeeMenuComponentIds.length > 0) {
                this.hm.app.removeComponents(this.employeeMenuComponentIds);
                this.employeeMenuComponentIds = [];
                employeeMenuElement.innerHTML = '';
            }

            let response = await this.hm.app.fetchJson('employeesStatus', 'menu');

            this.hm.app.addComponentsFromRemoteResponse(employeeMenuElement, response);

            this.employeeMenuComponentIds = this.hm.app.initComponents(employeeMenuElement, true);

            if (typeof this.hm.app.components.currentEmployee_currentStatus !== typeof undefined) {
                //when the status changes, the whole employee menu gets reloaded
                this.hm.app.components.currentEmployee_currentStatus.element.addEventListener('change', () => { this.employeeMenu(); });
            }

            if (typeof response.currentEmployeesStatus !== typeof undefined) {
                this.currentEmployeesStatus = response.currentEmployeesStatus;

                let employeeBadge = document.getElementById('employeeMenuBadge');

                employeeBadge.classList.remove('badge-secondary', 'badge-success', 'badge-warning', 'badge-danger');

                switch (this.currentEmployeesStatus) {
                    case 'working':
                        employeeBadge.classList.add('badge-success');
                        break;
                    case 'break':
                        employeeBadge.classList.add('badge-warning');
                        break;
                    case 'notWorking':
                        employeeBadge.classList.add('badge-danger');
                        break;
                }
            }
        }
    }
};

module.exports = session;